import LakeyardVideo from "../../assets/videos/Lakeyard.mp4";
import LakeyardPoster from "../../assets/videos/Lakeyard-poster.jpg";
import LightHouseVideo from "../../assets/videos/Lighthouse.mp4";
import LightHousePoster from "../../assets/videos/Lighthouse-poster.jpg";
import NorthedVideo from "../../assets/videos/Northed.mp4";
import NorthedPoster from "../../assets/videos/Northed-poster.jpg";
import GoodDaysVideo from "../../assets/videos/GoodDays.mp4";
import GoodDaysPoster from "../../assets/videos/GoodDays-poster.jpg";
import MatchaVideo from "../../assets/videos/Matcha.mp4";
import MatchaPoster from "../../assets/videos/Matcha-poster.jpg";
import RistaVideo from "../../assets/videos/RITSA.mp4"
import RistaPoster from "../../assets/videos/RiTSA-poster.jpg"
import HabitatVideo from "../../assets/videos/HABITAT.mp4";
import HabitatPoster from "../../assets/videos/HABITAT-poster.webp";
import GoodDays2Video from "../../assets/videos/GoodDays2.mp4";
import GoodDays2Poster from "../../assets/videos/GoodDays2-poster.webp";
import GoodDays3Video from "../../assets/videos/GoodDays3.mp4";
import GoodDays3Poster from "../../assets/videos/GoodDays3-poster.webp";

import {Link} from "react-router-dom";
import '../../assets/sass/destinations.scss';
import DestinationVideo from "../components/DestinationVideo";

export default function DestinationsSection() {

    return (
        <section className="our-destinations">

            <div className="display-5 text-center text-uppercase fw-normal text-accent py-3">
                our destinations
            </div>

            <div className="container">
                <div className="row gx-0 mb-3 flex-lg-row-reverse">

                    <div className="col-lg-4 mb-3 mb-lg-0 d-flex align-items-center justify-content-center">
                        <a
                            href="https://www.instagram.com/gettowander/"
                            target="_blank"
                            rel="noreferrer"
                            className="p-3 d-flex align-items-center text-center text-decoration-none color-black"
                            style={{backgroundColor: "#f1f1f1"}}>
                            <div
                                className="d-flex align-items-center justify-content-center bg-black rounded-5 me-2 "
                                style={{width: '60px', height: '60px'}}>
                                <i className="fs-2  ri-instagram-line text-white"/>
                            </div>
                            <span className="text-capitalize">get to wander</span>
                        </a>
                    </div>

                    <div className="col-lg-8">
                        <DestinationVideo poster={LakeyardPoster}
                                          source={LakeyardVideo}
                                          linkLabel={'LAKEYARD'}
                                          linkPath={'/projects/Lakeyard'}
                                          autoPlay={true}
                                          customStyle={false}/>
                    </div>
                </div>

                <div className="row gx-3">
                    <div className="col-lg-6">
                        <DestinationVideo poster={HabitatPoster}
                                          source={HabitatVideo}
                                          linkLabel={'HABITAT'}
                                          linkPath={'/projects/Habitat'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={GoodDays2Poster}
                                          source={GoodDays2Video}
                                          linkLabel={'Good Days'}
                                          linkPath={'/projects/GoodDays-2'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={GoodDays3Poster}
                                          source={GoodDays3Video}
                                          linkLabel={'Good Days'}
                                          linkPath={'/projects/GoodDays-2'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={RistaPoster}
                                          source={RistaVideo}
                                          linkLabel={'RISTA'}
                                          linkPath={'/projects/Rista'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={LightHousePoster}
                                          source={LightHouseVideo}
                                          linkLabel={'THE LIGHTHOUSE'}
                                          linkPath={'/projects/Lighthouse'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={NorthedPoster}
                                          source={NorthedVideo}
                                          linkLabel={'NORTHED'}
                                          linkPath={'/projects/Northed'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={GoodDaysPoster}
                                          source={GoodDaysVideo}
                                          linkLabel={'Good Days'}
                                          linkPath={'/projects/GoodDays'}/>
                    </div>

                    <div className="col-lg-6">
                        <DestinationVideo poster={MatchaPoster}
                                          source={MatchaVideo}
                                          linkLabel={'Matcha'}
                                          linkPath={'/projects/Matcha'}/>
                    </div>
                </div>

                <div className="p-5 text-center">
                    <Link
                        to={`/projects`}
                        className="text-decoration-none fw-normal px-4 btn btn-outline-dark rounded-0 text-uppercase btn-lg py-3 bg-accent-black text-accent-white" >
                        view all projects
                    </Link>
                </div>
            </div>
        </section>
    );
}